import { render, staticRenderFns } from "./ResidentStatementWidget.vue?vue&type=template&id=2e3556ea&scoped=true&"
import script from "./ResidentStatementWidget.vue?vue&type=script&lang=ts&"
export * from "./ResidentStatementWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentStatementWidget.vue?vue&type=style&index=0&id=2e3556ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3556ea",
  null
  
)

export default component.exports